import Teaching from '../../../../../public/img/illustration-teaching.svg';
import Image from '../../../../../public/img/page-feature-image.webp';
import { FontSize } from '../../../../constants/FontSize';
import { PageUrl } from '../../../../constants/PageUrl';
import { SectionId } from '../../../../constants/SectionId';
import Color from '../../../../styles/Color';
import SectionTitle from '../../atoms/SectionTitle';
import { SectionWrapper } from '../../templates/SectionWrapper';
import { CircleImageWithLink } from './CircleImageWithLink';
import styles from './environments.module.scss';

export const Environments = () => (
  <SectionWrapper id={SectionId.DAYCARE_ENVIRONMENTS} backgroundColor={Color.brandGreen100}>
    <SectionTitle fontSize={FontSize.MEDIUM} variant="border">
      『できた！』をたくさん積み重ねる
      <br />
      モンテッソーリ保育環境
    </SectionTitle>
    <div className={styles['content-wrapper']}>
      <p className={styles['body-text']}>
        当園では、少人数制とモンテッソーリ教育に精通する先生たちの適切な導きにより、子どもの「やりたい！」を「できた！」へ変える環境を作っています。
        <br />
        <br />
        保育士がひとりひとりの興味を逃さず見守ることで、考える機会を与え、自主性と好奇心を深めます。
        <br />
        <br />
        日々の生活の中で、小さな成功体験を積み上げることで達成感が育まれ、さらなる成長へのサイクルを作ります。
        <br />
        <br />
        ご家庭とは連絡帳でのやり取りに加え、個別面談などを定期的に行い、園での子どもの様子や関わり方を共有します。
      </p>
      <CircleImageWithLink
        label="特徴を詳しく見る →"
        href={PageUrl.DAYCARE_FEATURES}
        imageSrc={Image}
        color={Color.brandGreen300}
      />
    </div>
    <Teaching className={styles.teaching} />
  </SectionWrapper>
);
